var progress = $(".progress");
var progresspointbackgroundTwo = $("#progress-point-background-two");
var progresspointnumberTwo = $("#progress-point-number-two");
var progresspointbackgroundThree = $("#progress-point-background-three");
var progresspointnumberThree = $("#progress-point-number-three");
var progresspointbackgroundFour = $("#progress-point-background-four");
var progresspointnumberFour = $("#progress-point-number-four");
var progresspointbackgroundFive = $("#progress-point-background-five");
var progresspointnumberFive = $("#progress-point-number-five");
var paymentannotation = $("#payment-annotation");
var scrollSpeed = 600;

function clearProgress() {
    // let el = progress[0];
    //
    // let classes = el.className.split(" ").filter(function(c) {
    //     return c.lastIndexOf('state', 0) !== 0;
    // });
    //
    // el.className = classes.join(" ").trim();
}

function setProgressPoint(step) {
    let progressPoint = $('.progress-point[data-step="' + step + '"]');

    let nextPoints = progressPoint.nextAll('.progress-point');
    let prevPoints = progressPoint.prevAll('.progress-point');
    let activePoints = prevPoints.add(progressPoint);

    nextPoints
        .find('.progress-point-background-container')
        .removeClass('font-blue');

    nextPoints
        .find('.progress-number-container')
        .addClass('font-dark')
        .removeClass('fa-inverse');

    activePoints
        .find('.progress-point-background-container')
        .addClass('font-blue');

    activePoints
        .find('.progress-number-container')
        .removeClass('font-dark')
        .addClass('fa-inverse');
}

let steps = {
    // Cart resume
    "one": {
        onEnter: function() {
            clearProgress();
            setProgressPoint('one');

            progress.addClass('state-one');

            let heading = $('#headingOne');

            heading
                .addClass('completed')
                .nextAll('.portlet-head')
                .removeClass('completed');

            $('html, body').animate( {
                scrollTop: heading.offset().top - heading.outerHeight(),
            }, scrollSpeed);
        }
    },
    // User informations
    "two": {
        onEnter: function() {
            clearProgress();
            setProgressPoint('two');

            progress.addClass("state-two");
            paymentannotation.addClass("pb-3");

            let heading = $('#headingOne');

            heading
                .addClass('completed')
                .nextAll('.portlet-head')
                .removeClass('completed');

            $('html, body').animate( {
                scrollTop: heading.offset().top - heading.outerHeight(),
            }, scrollSpeed);
        },
    },
    // Billing address
    "two-bis": {
        onEnter: function() {
            clearProgress();
            setProgressPoint('two');

            progress.addClass("state-two-bis");

            let heading = $('#headingTwo');

            heading
                .addClass('completed')
                .nextAll('.portlet-head')
                .removeClass('completed');

            $('html, body').animate( {
                scrollTop: heading.offset().top - heading.outerHeight(),
            }, scrollSpeed);
        },
    },
    // Shipping method
    "three": {
        onEnter: function() {
            clearProgress();
            setProgressPoint('three');

            progress.addClass("state-three");

            let heading = $('#headingTwo');

            heading
                .addClass('completed')
                .nextAll('.portlet-head')
                .removeClass('completed');

            $('html, body').animate( {
                scrollTop: heading.offset().top - heading.outerHeight(),
            }, scrollSpeed);

            let activeCard = $('#collapseFour').find('.card-shipping.active-card');

            if (activeCard.length) {
                activeCard.trigger('click');
            }
        },
    },
    // Payment
    "four": {
        onEnter: function() {
            clearProgress();
            setProgressPoint('four');

            progress.addClass("state-four");

            let heading = $('#headingFour');

            heading
                .addClass('completed')
                .nextAll('.portlet-head')
                .removeClass('completed');


            $('html, body').animate( {
                scrollTop: heading.offset().top - heading.outerHeight(),
            }, scrollSpeed);
        },
    }
};

$(document).on('click', '#cart-informations .portlet-head.completed', function() {
    let content = $(this).next('.collapse');
    content.collapse('show');

    let stepKey = $(this).data('step');

    // if (steps.hasOwnProperty(stepKey)) {
    //     steps[stepKey].onEnter();
    // }
});

// Step 1 -> Step 2
$(document).on('click', '#btn-go-state-two', function () {
    // steps["two"].onEnter();
    //
    // if (typeof ga !== 'undefined') {
    //     ga('send', 'event', 'Panier', 'cart_step_1', 'Cart step 1');
    // }
});

// Step 2 - Logged in -> Step 2.bis (btn-go-state-two-bis)
$(document).on('submit', 'form.form-order-account-information', function (e) {
    e.preventDefault();
    let form = $(this);

    $.ajax({
        url: form.attr('action'),
        data: form.serialize(),
        method: form.attr('method'),
        success: function () {
            // steps["three"].onEnter();
            // $('#collapseFour').collapse('show');
            $('button[data-target="#mode"]').tab('show');

            if (typeof ga !== 'undefined') {
                ga('send', 'event', 'Panier', 'cart_step_2', 'Cart step 2');
            }
        },
        error: function (response) {
            $('#collapseTwo').html(response.responseJSON.html);
        }
    });

});

// Colissimo shipping
$(document).on('click', '#btn-go-state-three', function (event) {
    // event.preventDefault();
    //
    // steps["four"].onEnter();
    // $('#collapseFive').collapse('show');
    //
    // if (typeof ga !== 'undefined') {
    //     ga('send', 'event', 'Panier', 'cart_step_4', 'Cart step 4');
    // }
});

